import React from 'react';

import { accountRoutePaths } from '../../routes/accountRoutePaths';
import AppLessShell from '../AppLess/AppLessShell';
import Profile from './Profile';

const AppLessMyAccount = () => {
  return (
    <AppLessShell contentLayout="page" pageTestId="my-account-page">
      <Profile strictToParent toParent={accountRoutePaths.NoOrganisationAccess} />
    </AppLessShell>
  );
};

export default AppLessMyAccount;
